import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CustomMessageShowType } from '../../domain/enums/CustomMessageShowType'
import { CreateUpdateCustomMessageEntity } from '../../domain/entities/CreateUpdateCustomeMessageEntity'
import { UserAppType } from '../../domain/enums/UserAppType'

export class CreateUpdateCustomMessageModel extends CreateUpdateCustomMessageEntity {
  isEnabled: boolean = false
  showType: CustomMessageShowType = CustomMessageShowType.DAILY
  userIds?: string[] = []
  regionIds?: number[] = []
  districtIds?: number[] = []
  userAppTypes: UserAppType[] = [UserAppType.CLIENT]

  constructor(dataDto: CreateUpdateCustomMessageEntity) {
    super()
    mapEntityProperties<CreateUpdateCustomMessageModel>(this, dataDto, {
      exclude: ['regions', 'users', 'districts'],
      map: {
        regionIds: dataDto.regions?.map((item) => item.id).filter((id): id is number => id !== undefined),
        districtIds: dataDto.districtIds || dataDto.districts?.map((item) => item.id).filter((id): id is number => id !== undefined),
        userIds: dataDto.users?.map((item) => item.id),
       }
    })
  }
}
